import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { MailRibbonGroupId } from 'owa-ribbon-ids';

/**
 * Maps each group to its corresponding string for the corresponding group
 */
export const defaultGroupStringMap = new Map<RibbonGroupId, string>()
    .set(MailRibbonGroupId.Group_AddIns, GroupStrings.addIns_GroupButton)
    .set(MailRibbonGroupId.Group_Clipboard_Message, GroupStrings.clipboard_Group)
    .set(MailRibbonGroupId.Group_Clipboard_Format, GroupStrings.clipboard_Group)
    .set(MailRibbonGroupId.Group_Delete, GroupStrings.delete_GroupButton)
    .set(MailRibbonGroupId.Group_Download, GroupStrings.download_GroupButton)
    .set(MailRibbonGroupId.Group_Encrypt, GroupStrings.encrypt_Group)
    .set(MailRibbonGroupId.Group_Find, GroupStrings.find_GroupButton)
    .set(MailRibbonGroupId.Group_BasicText, GroupStrings.basicText_Group)
    .set(MailRibbonGroupId.Group_Paragraph, GroupStrings.paragraph_Group)
    .set(MailRibbonGroupId.Group_Illustrations, GroupStrings.illustrations_Group)
    .set(MailRibbonGroupId.Group_ImmersiveReader, GroupStrings.immersiveReader_GroupButton)
    .set(MailRibbonGroupId.Group_Include, GroupStrings.include_Group)
    .set(MailRibbonGroupId.Group_Insights, GroupStrings.insights_GroupButton)
    .set(MailRibbonGroupId.Group_Links, GroupStrings.links_Group)
    .set(MailRibbonGroupId.Group_Move, GroupStrings.move_GroupButton)
    .set(MailRibbonGroupId.Group_Move_and_Delete, GroupStrings.moveAndDelete_GroupButton)
    .set(MailRibbonGroupId.Group_Names, GroupStrings.names_Group)
    .set(MailRibbonGroupId.Group_New, GroupStrings.new_GroupButton)
    .set(MailRibbonGroupId.Group_Offline, GroupStrings.offline_GroupButton)
    .set(MailRibbonGroupId.Group_Print, GroupStrings.print_GroupButton)
    .set(MailRibbonGroupId.Group_Protection, GroupStrings.protection_GroupButton)
    .set(MailRibbonGroupId.Group_QuickSteps, GroupStrings.quickSteps_GroupButton)
    .set(MailRibbonGroupId.Group_Respond, GroupStrings.respond_GroupButton)
    .set(MailRibbonGroupId.Group_RibbonCustomizer, '') //Ribbon customizer never has displayed name
    .set(MailRibbonGroupId.Group_Save, GroupStrings.save_Group)
    .set(MailRibbonGroupId.Group_Send, GroupStrings.send_GroupButton)
    .set(MailRibbonGroupId.Group_Sensitivity, GroupStrings.sensitivity_Group)
    .set(MailRibbonGroupId.Group_Speech, GroupStrings.speech_GroupButton)
    .set(MailRibbonGroupId.Group_Sync, GroupStrings.sync_GroupButton)
    .set(MailRibbonGroupId.Group_Tables, GroupStrings.tables_Group)
    .set(MailRibbonGroupId.Group_Tags, GroupStrings.tags_GroupButton)
    .set(MailRibbonGroupId.Group_ToggleLeftPane, '') // Toggle group never displays group name
    .set(MailRibbonGroupId.Group_Toolbar_Home, '') // Toolbar groups never have displayed named
    .set(MailRibbonGroupId.Group_Toolbar_Message, '') // Toolbar groups never have displayed named
    .set(MailRibbonGroupId.Group_Undo, GroupStrings.undo_GroupButton)
    .set(MailRibbonGroupId.Group_Voice, GroupStrings.voice_Group);
